import React from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import { store } from '../../index';
import { Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

export const TOOLBAR_HEIGHT = 64;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.paper,
      maxHeight: TOOLBAR_HEIGHT,
      minHeight: TOOLBAR_HEIGHT,
    },
    toolbar: {
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
      maxHeight: TOOLBAR_HEIGHT,
      minHeight: TOOLBAR_HEIGHT,
    },
    rightButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    loadingSpinner: {
      marginLeft: '1em',
    },
    joinButton: {
      margin: '1em',
    },
    displayName: {
      margin: '1.1em 0.6em',
      color: theme.palette.text.primary,
    },
  })
);

function SimpleMenuBar() {
  const classes = useStyles();

  return (
    <AppBar className={classes.container} position="static">
      <Toolbar className={classes.toolbar}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {store.tenantLogo ? (
            <img src={store.tenantLogo} style={{ height: '40px', marginLeft: '5px' }} alt="Logo" />
          ) : null}
        </div>
        <Typography className={classes.displayName}>
          {store.tenantProjectName ? store.tenantProjectName : null}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default observer(SimpleMenuBar);
